module.exports = __webpack_public_path__ + "static/media/Customer.42e49a92.jpg";